import { Controller } from "@hotwired/stimulus"

// Follow the latest message on entry; never pull someone away from older history.
export default class extends Controller {
  connect() {
    this.followLatest = true
    this.frame = requestAnimationFrame(() => this.scrollToLatest())
  }

  scrolled() {
    this.followLatest = this.element.scrollHeight - this.element.clientHeight - this.element.scrollTop < 64
  }

  imageLoaded() {
    if (this.followLatest) this.scrollToLatest()
  }

  resized() {
    if (!this.followLatest) return
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => this.scrollToLatest())
  }

  scrollToLatest() {
    this.element.scrollTop = this.element.scrollHeight
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }
}
